import type { Leasing } from '../../../../../types'

export function leasingReportColumns() {
  const exportColumns: { key: keyof Leasing; header: string; width: number }[] = [
    { key: 'accountID', header: 'Kontonr', width: 15 },
    { key: 'regNo', header: 'Regnr', width: 15 },
    { key: 'vehicleID', header: 'Kjøretøy Id', width: 15 },
    { key: 'consolidatedAgreementID', header: 'Samleavtale ID', width: 20 },
    { key: 'consolidatedAgreement', header: 'Samleavtale', width: 30 },
    { key: 'driverName', header: 'Sjåfør', width: 25 },
    { key: 'maxKm', header: 'Maks km', width: 15 },
    { key: 'totalTerms', header: 'Terminer totalt', width: 10 },
    { key: 'termsNow', header: 'Terminer løpt', width: 15 },
    { key: 'remainingTerms', header: 'Terminer gjenstår', width: 20 },
    { key: 'startDate', header: 'Startdato', width: 15 },
    { key: 'returnDate', header: 'Returdato', width: 15 },
    { key: 'termLeasing_incl_VAT', header: 'Leasingleie mnd inkl. mva', width: 20 },
    { key: 'restLeasing_incl_VAT', header: 'Leasing forpliktelser ink. mva', width: 25 },
    { key: 'restLeasing_excl_VAT', header: 'Leasing forpliktelser eks. mva', width: 25 },
  ]

  return exportColumns
}
